export default __webpack_public_path__ + "static/media/mine.46ec5947.jpg";